import { render, staticRenderFns } from "./reisetermin-card-flugdata-releasepruefung.vue?vue&type=template&id=29da8b7e"
import script from "./reisetermin-card-flugdata-releasepruefung.vue?vue&type=script&lang=js"
export * from "./reisetermin-card-flugdata-releasepruefung.vue?vue&type=script&lang=js"
import style0 from "./reisetermin-card-flugdata-releasepruefung.vue?vue&type=style&index=0&id=29da8b7e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports